import { render, staticRenderFns } from "./StudentDashBoardPage.vue?vue&type=template&id=7633d08a&"
import script from "./StudentDashBoardPage.vue?vue&type=script&lang=ts&"
export * from "./StudentDashBoardPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports